<!--
 * @Author: Merlin
 * @Date: 2025-06-19 14:08:34
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-25 11:23:27
 * @Description: 
-->

<template>
    <article
        class="game-wrap relative"
    >
        <div class="game-background max-width">
            <!-- 纯背景，暂无子元素 -->
        </div>

        <div class="game-inner max-width py-3 px-3 sm:py-2 relative">
            <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-0">
                <GameSettingsButtonFast
                    v-model="gameStore.redpacket.fast"
                />
                <GameSettingsButtonRule
                    v-model="oVisible.isOpenRule"
                    name="redpacketGame"
                />
                <GameSettingsButtonVocie
                    v-model="settingStore.inhouseGames.sound.on"
                    v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                    :saveAfterChange="true"
                ></GameSettingsButtonVocie>
            </GameSettingsDiceTabsWrapper>
            <!--
                ↑ 通用控制条 
                ↓ 游戏区 
            -->
            <section class="message-box">
                <ul class="msg-list">
                    <li class="one-msg"
                        v-for="(oCur, idx) of oPlayerCenter.aPlayerMsg"
                        :key="oCur.ts"
                    >
                        <UserAvatar
                            size='20px'
                            :src="oCur.avatar"
                        />
                        <p>
                            {{ oCur.msg }}
                        </p>
                    </li>
                </ul>
                <div class="first-line">
                    <button class="history-btn"
                        @click="showHistoryList"
                    >
                        <IconSvgUse use="icon-statistic-3" size="18px"/>
                        {{ $t('History') }}
                    </button>
                    <!-- 左右分界 -->
                    <div class="big-news"> 
                        <TransitionGroup name="pop">
                            <p class="mb-1"
                                v-for="(oUser, idx) of oPlayerCenter.aPlayerDeeds.slice(-2)"
                                :key="oUser.ts"
                                vvif="oPlayerCenter.aPlayerDeeds.length"
                            >
                                <IconSvgUse
                                    use="icon-menu-promotions"
                                    size="22px"
                                />
                                <UserAvatar
                                    class="inline-flex mx-1"
                                    size='18px'
                                    :src="oUser.avatar"
                                />
                                <span>
                                    {{
                                        $t('redPacketMines.actionEvade', {
                                            user: oUser.username02,
                                            times: oUser.combo,
                                        })
                                    }}
                                </span>
                            </p>
                        </TransitionGroup>
                    </div>
                </div>
            </section>

            <section
                :ref="el => oStageDom = el"
                :data-height="iStageHeight"
                class="game-stage packet-pool"
                :class="{
                    'small': isStageSmall,
                }"
            >
                <div class="cards"
                    :data-stage-small="isStageSmall"
                    :ref="el => oCardsBoxDom = el" 
                >
                    <template v-if="!isStageSmall">
                        <Packet
                            v-for="(idx001) of 2"
                            :iType="aPartitionPlanArr[0]"
                            class="one-card hiding-card"
                        /> 
                        <!-- ↑ 撑高卡，不可见 -->
                        <span class="arrow arrow_left"
                            @click="() => fnMoving(-1)"
                        >
                            <q-icon name="arrow_back_ios" />
                            <q-icon name="arrow_back_ios" />
                        </span>
                        <span class="arrow arrow_right"
                            @click="() => fnMoving(1)"
                        > 
                            <q-icon name="arrow_forward_ios" />
                            <q-icon name="arrow_forward_ios" />
                        </span>
                    </template>
                    <!-- ↓ 三类动态卡 -->
                    <div v-for="(cur, idx) of oRoomInfo.aPacketsArr"
                        :key="idx"
                        class="one-card moving-card"
                        :class="{[aPositionUsing[idx]]: true}" 
                    >
                        <Packet
                            :iType="cur.num" 
                            :disabled="cur.totalAccount == 0" 
                            :info="cur" 
                            :amount="oForm4Sending.amount"
                            :clicked="cur.clicked"
                            @click="fnCollectPacket(cur)"
                        />
                        <!--
                            ↑ 真包，可点击 
                            ↓ 插入假包的动画
                        --> 
                        <!-- 如果不可见就不应用动画 -->
                        <TransitionGroup
                            :name="isPageVisible ? 'fade' : ''" 
                            tag="div"
                            class="moving-cards-box"
                            :css="isPageVisible" 
                        >
                            <Packet
                                v-for="(onePack, i02) of cur.aList" 
                                :amount="oForm4Sending.amount"
                                :key="onePack.id"
                                :iType="cur.num"
                                :data-order-val="idx+1"
                                :info="cur"
                                :animationCard="isPageVisible" 
                            />
                        </TransitionGroup>
                    </div>
                </div>
                <!-- ↓ 浮动按钮：左中右 -->
                <div class="drowning-box">
                    <button class="floating-btn"
                        @click="() => oVisible.hallList = true" 
                    >
                        <IconSvgUse 
                            use="circle-narrow"
                            size="15px"
                        />
                        {{ $t('redPacketMines.ChangeRoom') }}
                    </button>
                    <button class="center-btn"
                        :class="{
                            'auto-running': oAutoRunningManager.collectingAutoOn, 
                            'blakened': !aPacketCollectable.length, 
                        }"
                        @click="()=> fnAutoRunningSwitch('collecting', !oAutoRunningManager.collectingAutoOn)"
                    >
                        <img src="@/pages/casino/redpacketGame/img/ring-light.webp"
                            class="spining-ring" 
                            :class="{
                                'animate-spin': oAutoRunningManager.collectingAutoOn,
                            }"
                        />
                        <template v-if="oAutoRunningManager.collectingAutoOn">
                            <img v-if="locale == 'cn'"
                                src="@/pages/casino/redpacketGame/img/auto-grabing-cn.webp"
                            />
                            <img v-else
                                src="@/pages/casino/redpacketGame/img/auto-grabing-en.webp" 
                            />
                        </template>
                        <template v-else>
                            <img v-if="locale == 'cn'"
                                src="@/pages/casino/redpacketGame/img/auto-grab-cn.webp"
                            />
                            <img v-else
                                src="@/pages/casino/redpacketGame/img/auto-grab-en.webp" 
                            />
                        </template>
                    </button>
                    <!-- 左右分界 -->
                    <button class="floating-btn"
                        @click="fnViewPlayersInRoom"
                    >
                        <IconSvgUse 
                            use="icon-online"
                            size="18px"
                        />
                        {{ oRoomInfo.online }}
                    </button>
                </div>
            </section>
            <!--
                ↑ 游戏舞台，游戏区 
                | ================================================
                | ================================================
                | ================================================ 
                ↓ 下注面板，表单
            -->
            <section class="rows-wrap">
                <h5 class="title-row">
                    {{ $t('redPacketMines.setBombNumber') }}: 
                </h5>
                <div class="first-row"
                    :class="{'animate-shake': iFirstRowShaking}"
                >
                    <ClientOnly>
                        <button 
                            v-for="(intNo, idx) of aBombNumbers"
                            :key="intNo"
                            @click="fnSetBombNo(intNo)"
                            class="bomb-no"
                            :v-click-and-rest="intNo == 10"
                            :class="{
                                active: intNo == oForm4Sending.mine,
                                'random-btn': intNo == 10,
                            }"
                        >
                            {{ 
                                intNo == 10
                                ? $t('redPacketMines.Random')
                                : intNo
                            }}
                        </button>
                    </ClientOnly>
                </div>
                <div class="center-row">
                    <div class="left-part border rounded-[10px] border-[#4b5b74] bg-[#161f2c] p-2.5">
                        <span class="amount">
                            <ClientOnly>
                                <CurrentCoin
                                    :name="userStore.currentCurrency" 
                                    class="w-[24px]"
                                />
                                {{ oForm4Sending.amount }}
                            </ClientOnly>
                        </span>
                        <div class="packet-setter">
                            <div class="btn-coat">
                                <ButtonGrayButton
                                    :fullWidth="false"
                                    v-for="cur of oRoomInfo.aPacketsArr"
                                    :key="cur.num"
                                    @click="oForm4Sending.num = cur.num"
                                    :class="{
                                        active: oForm4Sending.num == cur.num,
                                    }"
                                >
                                    {{ $t('redPacketMines.packetsShortened', {val: cur.num}) }}
                                </ButtonGrayButton>
                            </div>
                        </div>
                    </div>
                    <ButtonThe3DButton
                        class="right-part bet-btn"
                        :class="{}"
                        :disabled="!!0"
                        color="red" 
                        v-click-and-rest
                        @click="fnSendOnePacket"
                    >
                        {{ $t('redPacketMines.sendRedPacket') }}
                    </ButtonThe3DButton>
                </div>
                <h5 class="title-row">
                    {{ $t('redPacketMines.packetQty2Send') }}: 
                </h5>
                <div class="last-row">
                    <div class="range left-part mines-control__mines-count"
                        :style="{
                            '--height': '7px',
                            '--knob-size': '16px',
                            '--rail-color': 'rgba(17, 25, 35, 0.8)',
                            '--fill-color': '#2283f6',
                            '--knob-color': '#2283f6',
                            '--percent': `${(oForm4Sending.count) / (iPacketMaxQty - 1) * 100}%`, 
                        }"
                    >   
                        <img class="redpacket-pic"
                            src="@/pages/casino/redpacketGame/img/small_pack.png"
                        />
                        <span class="qty-box">
                            {{ oForm4Sending.count }} 
                        </span>
                        <input class="range__input"
                            type="range"
                            step="1"
                            min="1"
                            :max="iPacketMaxQty"
                            v-model="oForm4Sending.count"
                            :disabled="!!0"
                        >
                    </div>
                    <!-- ↑ 选择发包的数量 -->
                    <!-- ↓ 仅用于测试 -->
                    <ButtonThe3DButton
                        v-show="isMetaDev"
                        class="right-part"
                        size="md"
                        color="blue"
                        @click="() => fnAutoRunningSwitch('sending', !oAutoRunningManager.sendingAutoOn)" 
                    >
                        {{ $t('redPacketMines.autoSend') }}
                        <CasinoWidgetRunningIcon
                            class=""
                            v-if="oAutoRunningManager.sendingAutoOn"
                        ></CasinoWidgetRunningIcon>
                    </ButtonThe3DButton>
                </div>
            </section>
        </div>
        <!-- 
            ↑ 游戏主体 
            | ==========================================================
            | ==========================================================
            | ==========================================================
            | ==========================================================
            ↓ 游戏结果浮层，弹出窗口等元素  
        -->
        <section class="game-result-animation max-width" 
            v-show="oVisible.resultVisible"
            @click="fnCloseResult"
        >
            <!-- 这里的子元素不用 v-if 而用 v-show 以改善性能 --> 
            <div class="result-win" 
                v-show="oVisible.resultVisible && (oGameResult.hasWon === true)"
            >
                <Transition
                    appear
                    :name="gameStore.redpacket.fast ? '' : 'popout'" 
                >
                    <div class="bg01" v-show="oGameResult.hasWon"> 
                        <img  src="../img/game_result/win_bg01.webp" />
                    </div>
                </Transition>
                <div class="result-detail" >
                    <Transition
                        appear
                        :name="gameStore.redpacket.fast ? '' : 'popout'" 
                    >
                        <div class="content-box" v-show="oGameResult.hasWon"> 
                            <img class="pack-pic"
                                src="../img/game_result/win_pic.webp"
                            />
                            <div class="top-detail">
                                <h5 class="congratulation">
                                    {{ $t('redPacketMines.congratulation') }}  
                                </h5>
                                <p class="win-amount">
                                    +{{ getFixed(oGameResult.winAmount) }}
                                </p>
                                <div class="bottom-info">
                                    <!-- (这个连杀，从3开始)，出处： https://t.me/c/2370295395/3/12857 --> 
                                    <span class="multi-kill"
                                        :class="{
                                            [oGameResult.combo >= 3 ? 'visible': 'invisible']: true, 
                                        }"
                                    >
                                        <span class="text">
                                            {{
                                                $t(
                                                    'redPacketMines.multiKill',
                                                    {num: oGameResult.combo},
                                                )
                                            }}
                                        </span>
                                    </span>
                                    <span class="odds"> 
                                        {{ $t('redPacketMines.Odds') }}  
                                        x<em>{{ getFixed(oGameResult.rate) }}</em>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Transition>
                    <div class="content-box spark-wrap"
                        v-show="oVisible.phase02" 
                    > 
                        <img class="animate-ping" 
                            src="../img/game_result/win_spark.webp"
                            v-for="(cur, idx) of 5"
                            :key="idx"
                            :style="{'animation-duration': `${cur * 170 + 900}ms`}"
                            :class="{
                                [`spark0${cur}`]: true, 
                            }"
                        />
                    </div>
                </div>
            </div>
            <!--
                输赢分界 
            -->
            <div class="result-lose"
                v-show="oVisible.resultVisible && (oGameResult.hasWon === false)" 
            >
                <div class="center-box">
                    <img class="bg bg01" src="../img/game_result/lost_bg01.png" />  
                    <div class="center-child" >
                        <Transition
                            appear
                            :name="gameStore.redpacket.fast ? '': 'popout'"
                        >
                            <img class="smoke" src="../img/game_result/lost_smoke.webp"
                                v-show="!oGameResult.hasWon"
                            />
                        </Transition>
                    </div>
                    <Transition
                        appear
                        :name="gameStore.redpacket.fast ? '': 'bombed'"
                    >
                        <div class="center-child"
                            v-show="!oGameResult.hasWon"
                        >
                            <img class="bomb animate-bounce"
                                style="animation: shake 600ms ease-out;" 
                                src="../img/game_result/lost_bomb.webp"
                            />  
                        </div>
                    </Transition>
                    <div class="center-child" >
                        <Transition
                            appear
                            :name="gameStore.redpacket.fast ? '': 'bombed'"
                        >
                            <img class="fire"
                                src="../img/game_result/lost_fire.webp"
                                v-show="oVisible.phase02" 
                            />
                        </Transition>
                    </div>
                </div>
            </div>
        </section>
    </article>
    <!-- 
        ↑ 游戏区 
        =============================================
        ↓ 弹出窗口 
    -->

    <!-- ↓ 大厅列表窗口 -->
    <ModalTitle
        container-class=""
        :model-value="oVisible.hallList"
        :backdrop="true"
        @update:model-value="(newVal) => oVisible.hallList = !!newVal"
    >
        <!-- @update:model-value="onModelValue"  -->
        <template #header>
            <span class="text-[24px] leading-10">
                {{ `${$t('redPacketMines.SelectRoom')}` }} 
            </span>
        </template>
        <ul class="hall-list">
            <li v-for="(cur, idx) of aHallsList" 
                :key="idx"
                :class="{
                    active: cur.id == oRoute?.params?.id,
                    disabled: cur.disabled,
                }"
                @click="fnChangeHall(cur)" 
            >
                <img class="redpacket"
                    src="@/pages/casino/redpacketGame/img/small_pack.png"
                />
                <div class="into">
                    <span class="title">
                        {{ cur.myTitle }}
                    </span>
                    <span class="hall-ante">
                        {{ $t('redPacketMines.ante') }}
                        <CurrentCoin
                            size="16px"
                            class="mx-1"
                        />
                        <em>
                            {{ (cur.base * 1).toFixed(2) }}
                        </em>
                    </span>
                </div>
            </li>
        </ul>
    </ModalTitle>

    <!-- ↓ 玩家列表窗口 -->
    <ModalTitle
        container-class=""
        :model-value="oVisible.playerList"
        :backdrop="true"
        @update:model-value="(newVal) => oVisible.playerList = !!newVal"
        :bodyStyle="{
            'overflow-y': 'auto',
            'max-height': '70vh',
        }"
    >
        <!-- @update:model-value="onModelValue"  -->
        <template #header>
            <span class="text-[24px] leading-10">
                {{ `${$t('redPacketMines.PlayerList')}` }} 
            </span>
        </template>
        <div class="min-h-[250px]"> 
            <table class="players-list mb-4">
                <thead>
                    <tr>
                        <th>
                            {{ `${$t('redPacketMines.Username')}` }} 
                            /
                            <em class="quantify">{{ oPlayerCenter.aPlayerList.length }}</em>
                        </th>
                        <th>
                            {{ `${$t('redPacketMines.playerBalance')}` }} 
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(cur, idx) of oPlayerCenter.aPlayerList" 
                        :key="cur._id"
                        :class="{}"
                    >
                        <td class="play-info">
                            <span class="td-inner">
                                <UserAvatar
                                    size='20px'
                                    :src="cur.avatar"
                                />
                                <span class="play-name">
                                    ***{{ cur.username.slice(-2) }}
                                </span>
                            </span>
                        </td>
                        <td class="amount">
                            <span class="td-inner">
                                <CurrentCoin class="w-[24px]" name=""/>
                                &nbsp;
                                {{ number2LocaleString(cur.amount, 2) }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ModalTitle>
    
    <!-- ↓ 窗口：用于设定自动发包抢包的细节 -->
    <ModalTitle
        v-model="oAutoRunningManager.autoRunningConfigDialog"
        __title="$t('redPacketMines.PleaseSetRules')"
        :bodyClass="''"
    >
        <template #header>
            <div class="text-3xl py-[0px] px-[0px] font-bold !z-20 relative text-white p-0 leading-1" 
                style="width: calc(100% - 35px)"
            >
                <span class="text-[25px]">
                    {{ $t('redPacketMines.PleaseSetRules') }}
                </span>
            </div>
        </template>
        
        <div class="auto-collection-body">
            <template v-if="isDEV && (oAutoRunningManager.setting === 'sending')"> 
                <div class="auto-running-options">
                    <q-checkbox
                        v-for="(cur, idx) of oAutoRunningManager.sendingConfig.aPartitionPlans"
                        :key="idx"
                        color=""
                        :label="$t('redPacketMines.packets', {val: cur.value})"
                        v-model="cur.checked"
                    />
                </div>
                <p class="tips" >
                    <span v-if="oAutoRunningStatistic.sending.length">
                        {{ $t('redPacketMines.willStart') }}
                        <q-icon name="check_circle" />
                    </span>
                    <span v-else 
                        class="alert animate-bounce"
                    >
                        {{ $t('redPacketMines.atLeastOne') }}
                        <q-icon name="info" />
                    </span>
                </p>
                <div class="auto-collection-btn-wrap">
                    <ButtonThe3DButton
                        size="sm"
                        color="gray"
                        @click="() => fnAutoRunningSwitch('sending', false)"
                    >
                        {{ $t('Cancel') }}
                    </ButtonThe3DButton>
                    <ButtonThe3DButton
                        size="sm"
                        color="red"
                        class=""
                        :disabled="!oAutoRunningStatistic.sending.length"
                        @click="fnStartAutoRunning('sending')"
                    >
                        {{ $t('BetStart') }}
                    </ButtonThe3DButton>
                </div>
            </template>
            <!-- 
                ↑ 自动发包（以上部分仅用于测试）
                ↓ 自动抢包 
            -->
            <template v-else> 
                <div class="auto-running-options">
                    <q-checkbox
                        v-for="(cur, idx) of oAutoRunningManager.collectingConfig.aPartitionPlans"
                        :key="idx"
                        color=""
                        :label="$t('redPacketMines.packets', {val: cur.value})"
                        v-model="cur.checked"
                    />
                </div>
                <p class="tips" >
                    <span v-if="sUnableToGrab"
                        class="alert animate-bounce"
                    >
                        {{ sUnableToGrab }}
                        <q-icon name="info" />
                    </span>
                    <span v-else-if="oAutoRunningStatistic.collecting.length">
                        {{ $t('redPacketMines.willStart') }}
                        <q-icon name="check_circle" />
                    </span>
                    <span v-else 
                        class="alert animate-bounce"
                    >
                        {{ $t('redPacketMines.atLeastOne') }}
                        <q-icon name="info" />
                    </span>
                </p>
                <div class="auto-collection-btn-wrap">
                    <ButtonThe3DButton
                        size="sm"
                        color="gray"
                        @click="() => fnAutoRunningSwitch('collecting', false)"
                    >
                        {{ $t('Cancel') }}
                    </ButtonThe3DButton>
                    <ButtonThe3DButton
                        size="sm"
                        color="red"
                        class=""
                        :disabled="!oAutoRunningStatistic.collecting.length || !!sUnableToGrab"
                        @click="fnStartAutoRunning('collecting')"
                    >
                        {{ $t('BetStart') }}
                    </ButtonThe3DButton>
                </div>
            </template>
        </div>
    </ModalTitle>
    <!-- ↓ 历史“列表” 窗口 -->
    <HistoryList
        v-model="oVisible.historyList" 
    ></HistoryList>
    <!-- ↓ 历史“详情” 窗口，在此监听 route 参数变化并打开 -->
    <CasinoHistoryModalGameDetali
        :gameDropValue="'redpacket'"
    />
</template>

<script lang="ts" setup> 
import Packet from '../_components/packet.vue';
import HistoryList from '@/pages/casino/redpacketGame/_components/historyList.vue';
import NoticeDialog from '@/components/NoticeDialog.vue'; 
import { onBeforeRouteLeave } from 'vue-router';
import GameGBM from '@/assets/mp3/game_general_bgm.mp3';
import musicLose from '@/assets/mp3/redPacket/lose.mp3';
import musicWin from '@/assets/mp3/redPacket/win.mp3';
import musicSending from '@/assets/mp3/redPacket/sending.mp3';
import musicCollecting from '@/assets/mp3/redPacket/collecting.mp3';
// ------------------ 
import { getGameApi } from '@/common/js/gameAbout';
import { useGameSocket } from '~/socket/game';
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
import {useRedPacket} from '@/socket/game/redpacket'; 
import {toCloseLoading} from '@/layouts/gameCoat/ts/gameCoat';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import useGlobalStore from '@/stores/global'; 
import { Dialog } from 'quasar';
import {
    ActionInt,
    aPartitionPlans,
    aPartitionPlanArr as aPartitionPlanArrOriginal,
    getHallsList,
    fnGoIntoOneHall,
    fnGoToEntrance,
    type RunningType,
    type GameResultType,
} from '../ts/redPacketCommon';

const isDEV = import.meta.env.DEV_MODE; 
const isMetaDev = import.meta.dev;
const settingStore = useSettingsStore();
const oGlobalStore = useGlobalStore();
const userStore = useUserStore();
const joinStateStore = useJoinStateStore(); 
const gameStore = storeToRefs(settingStore).game;
// -------- ↑ store -------------------------------------- 
const oRoute = useRoute(); 
const { t: $tFn, locale } = useNuxtApp().$i18n;
const showNoticeDialog = useNoticeDialog();
const {
    // 进入游戏时报告入场，同时取下注最大/最小金额 
    EMIT_GAME_JOIN, 
} = useGameSocket();
const {
    ON_REDPACKET_BROADCAST,
    ON_REDPACKET_PLAYER_INFO,
    ON_REDPACKET_PLAYER_DEEDS, 
    EMIT_REDPACKET_BET, 
    EMIT_REDPACKET_LEAVE,
    EMIT_GET_REDPACKET_ROOM_PLAYERS,
} = useRedPacket();

// 音乐列表
const oMusicLib = {
    bg: {
        src: GameGBM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    win:{ src: musicWin, },
    lose:{ src: musicLose, },
    sending:{ src: musicSending, },
    collecting:{ src: musicCollecting, }, // 这顶似乎作用不大，
};

const oMusic = (
    import.meta.client
    ? new MusicControler(oMusicLib as any)
    : null
);

// ----- ↑ 导入公共资源 ----------------------
// ----- ↓ 本地数据 ----------------------


// 当前项目搜索到的： aPartitionPlans 基于都是用于测试 
type TwoSwitch = 'sendingAutoOn' | 'collectingAutoOn';
type TwoSwitchBooleans = {
    [K in TwoSwitch]: boolean;
};

interface AutoRunningSpecifics {
    autoRunningConfigDialog: boolean;
    autoSendingTimer: any; 
    autoCollectingTimer: any; 
    setting: ('' | RunningType);
    sendingConfig: {
        aPartitionPlans: any;
    }; 
    collectingConfig: any; 
}

type AutoRunningManager = TwoSwitchBooleans & AutoRunningSpecifics;

const isPageVisible = ref(true); // 页面是否处于激活状态
const isRoomExited = ref(false); // 是否已退出房间
let redpacketAskSum = 0; // 询问计数器
let redpacketPendingNavigation = null; // 保存待跳转的路径
let isSending = false; // 是否正在发红包 
let iCollectedAt = 0; // 记录上次抢包的时间戳（手动/自动都用到） 
let oInsertedPacketAt = { // 记录上次插入红包到舞台的时间（上次动画执行时间） 
    '3': 0, // 3人包
    '5': 0,
    '10': 0,
}; 
const iPacketMaxQty = 10; // 每次发包数量上限值 
const iManualCollectingGap = 0.7 * 1000; // “手动” 抢包操作间隔 
const iAutoCollectingGap = 2 * 1000; // “自动” 抢包操作间隔 
const iStageMinHeight = 330; // 小于此值启动小屏模式  
const aPartitionPlanArr = deepCopy(aPartitionPlanArrOriginal); // 固定的拆包方案 
const iOffset = ref(3);
const iFirstRowShaking = ref(false); 
const aAutoCollectionRecords = []; // 记录每次“自动抢包” 的成功性 
const oStageDom = ref(null);
const oCardsBoxDom = ref(null);
const iStageHeight = ref(iStageMinHeight + 1); 
const aBombNumbers = [...Array(11).keys()]; 
const aPositionOriginal = ['left', 'right', 'bottom']; 
const oPlayerCenter = reactive({
    aPlayerMsg: [],
    aPlayerList: [],
    aPlayerDeeds: [],
});

const oRoomInfo = reactive({
    online: 0, // 房间人数
    aPacketsArr: [], // 通过 fnSetPacketsWhileJoinning() 赋值 
    oPacketsStatistic: { // ↓ 数据示例 
        // "redPacket:data:1:1.25:cny": {},
        // "redPacket:data:1:1.5:cny": {},
        // "redPacket:data:1:1:cny": {},
    },
});

// 元素可见性管理中心 
const oVisible = reactive({
    isOpenRule: false,
    historyList: false, // 历史窗口 
    resultVisible: false, // 游戏结果 
    phase02: false, // 游戏结果窗口内部元素  
    hallList: !!0,
    playerList: !!0,
});

// 余额不足弹窗
const showLowBalanceDialog = ref(false);

// 游戏结果的数据结构 
interface GameResultTypePlus extends GameResultType{
    hasWon: null | boolean; 
}

// 投注表单  
const oForm4Sending = reactive({
    amount: '', // 不同房间对应不同金额，此值不提交，
    mine: null, // 雷号 0-9  
    count: 1, // 发送包的数量 
    num: aPartitionPlanArr[0], // 分割方案 
    action: 1, // 1是发包、2是抢包 
});

let timer4CloseGameResult = null; // 保存定时器，服务于游戏结果的展示 
// ↓ 保存游戏结果 
const oGameResult:GameResultTypePlus = reactive({
    hasWon: null, // null 输赢结果不明，布尔表示输赢结果 
    "game": { "_id": 21 }, 
    "user": {
        "_id": 0, // 70 
        "address": "",
        "avatar": "defaultAvatarName:male_05",
        "lvl": 1,
        "name": "", // User002x70 
    },
    "amount": 0,
    "action": 0,
    "count": 0,
    "rate": 0,
    "num": 0,
    "isMine": 0,
    "Mine": 1, // 
    "balanceBefore": 0,
    "currency": "cny",
    "roundNum": 0,
    "timestamp": '', // "2025-07-18T05:55:35Z",
    "winAmount": 0, // 1.23
    "tax": 0, // 0.00615
    "taxWinAmount": 0, // 1.22385
    "difference": 0,
    "confirmed": false,
    "minedTokens": 0,
    "rateToBTC": 0,
    "rateToUSD": 0,
    "_id": "", // 25071813553586988694
    "hid": 0, // 4882
    "combo": 0, 
});

const aPositionArr = ([
    ...aPositionOriginal,
    ...aPositionOriginal,
    ...aPositionOriginal,
]);

const oTwoSwitchKeys:{ // 收发红包的开关的属性名 
    [K in RunningType]: TwoSwitch; 
} = {
    sending: 'sendingAutoOn', 
    collecting: 'collectingAutoOn', 
};

// 红包“自动” 收发管理中心 
const oAutoRunningManager: AutoRunningManager = reactive({ 
    ...({ // 发包，内部属性都仅仅服务于测试 
        sendingAutoOn: false, 
        autoSendingTimer: null, 
        sendingConfig: {
            aPartitionPlans: aPartitionPlans.map(cur=>{
                return {...cur, checked: true};
            }), 
        }, 
    }),
    ...({ // 自动抢包 
        collectingAutoOn: false, 
        autoCollectingTimer: null, 
        collectingConfig: {
            aPartitionPlans: aPartitionPlans.map(cur=>{
                return {...cur, checked: true};
            }), 
        }, 
    }),
    setting: '', 
    autoRunningConfigDialog: false,  // 自动发/抢设定窗口可见性
});


// ↓ 自动发包抢包设定情况
const oAutoRunningStatistic = computed(()=> {
    const oResult = {
        sending: oAutoRunningManager.sendingConfig.aPartitionPlans.filter(cur => {
            return !!cur.checked; 
        }),
        collecting: oAutoRunningManager.collectingConfig.aPartitionPlans.filter(cur => {
            return !!cur.checked; 
        }),
    };
    return oResult;
});

// ↓ 厅列表 
const aHallsList = computed(getHallsList);

// ↓ 当前厅的信息 
const oRoomConfig = computed(() => { 
    for (const cur of (aHallsList.value || [])){
        if (Number(cur.id) == iTableID.value){
            console.log('redpacket 当前房间信息：', deepCopy(cur)); 
            return cur;
        }
    }
    // ↓ 替补项 
    return {}; 
});

/**
 * 基于用户余额的最大发包数量 
 */
const iMaxPacketSendable = computed(()=>{
    const balance = userStore.oNowCurrency.balance; 
    const base = Number(oRoomConfig.value?.base);
    if (!base){
        return 0;
    }
    const iResult = Math.floor(balance / base); 
    return iResult; 
});

/**
 * 基于用户余额的“可” 抢包类型统计
 */
const aPacketCollectable = computed(()=>{
    const balance = userStore.oNowCurrency.balance; 
    const base = Number(oRoomConfig.value?.base) || 0;
    const aResult = oRoomInfo.aPacketsArr.flatMap(cur => {
        if (balance < cur.rate * base){
            return []; // 余额不够，无法抢这个包
        }
        return [cur.num]; 
    });
    // 结果：[]、[10]、[10, 8] 
    return aResult; 
});

/**
 * 自动抢设定错误提示语 
 */
const sUnableToGrab = computed(()=>{
    const aResult = oAutoRunningManager.collectingConfig.aPartitionPlans.flatMap(cur=>{
        if (!cur.checked || aPacketCollectable.value.includes(cur.value)){
            return []; // 没选中，或余额足够，跳过 
        }
        return [cur.value]; 
    });
    if (aResult.length){
        return  $tFn('redPacketMines.unableToCollectThis', {
            num: aResult[0],
        });
    }
    return '';
});


// ↓ 当前厅 id（Table ID)  
const iTableID = computed(()=>{
    const iVal = Number(oRoute?.params?.id); 
    return iVal; 
});

const aPositionUsing = computed(()=>{
    if (isStageSmall.value){
        return ['', '', '']; // 无类名
    }
    const arr = aPositionArr.slice(iOffset.value);
    return arr; 
});

const isStageSmall = computed(()=>{
    return false; // 返回 return, 暂时关停小屏模式 
    // return iStageHeight.value <= iStageMinHeight;
});


// ===================================================================================
//          ↑ 陈列数据
//          ↓ 一些方法 
// ===================================================================================


// ↓ 开启【自动模式】设定窗口，或关闭自动模式 
const fnAutoRunningSwitch = (
    type: RunningType,
    on,
)=>{
    const noCanDo = (
        !!on
        && type == 'collecting'
        && !aPacketCollectable.value.length
    );
    if (noCanDo){
        joinStateStore.gameRunning = false; 
        showNegativeNotify({
            type: 'warning',
            position: 'top',
            timeout: 1_000 * 1.5, 
            message: $tFn('redPacketMines.autoModeUnusable'),
        });
        return;
    }
    const onVal = Boolean(on);
    const sKeyToSwitch = oTwoSwitchKeys[type];
    const oNewVal = {
        autoRunningConfigDialog: Boolean(onVal), // 开头窗口
        setting: (onVal ? type : ''), // 设定窗口类型 
        [sKeyToSwitch]: false, // 无论要开/关，这都应设为 false 
    };
    Object.assign(oAutoRunningManager, oNewVal); 
    // ↓ 无论要开/关、 都关停旧的定时器 
    if (type == 'sending'){
        clearInterval(oAutoRunningManager.autoSendingTimer);
    }else if (type == 'collecting'){
        joinStateStore.gameRunning = onVal; 
        clearInterval(oAutoRunningManager.autoCollectingTimer);
    }
};


/**
 * 启动自动发包/抢包（点击确认后执行的方法 
 */
const fnStartAutoRunning = (
    type: RunningType,
)=>{
    const keyToSwitch = oTwoSwitchKeys[type];
    Object.assign(oAutoRunningManager, {
        autoRunningConfigDialog: false, // 关闭窗口  
        [keyToSwitch]: true, // 启动自动模式  
    });
    if (type == 'sending'){
        // 开始定时发包，这个区块仅用于测试 
        const iFrequency = 2_000;
        oForm4Sending.mine = Math.floor(Math.random() * 10); 
        clearInterval(oAutoRunningManager.autoSendingTimer); 
        oAutoRunningManager.autoSendingTimer = setInterval(()=>{
            fnSendOnePacket(true); 
        }, iFrequency);
    }else if (type == 'collecting') { 
        // ↓ 立即检查是否有包可抢 
        fnCollectionChecker(); 
        clearInterval(oAutoRunningManager.autoCollectingTimer); 
        oAutoRunningManager.autoCollectingTimer = setInterval(()=>{
            fnCollectionChecker(); 
        }, iAutoCollectingGap + 10);
    }
};


/**
 * 关闭监听，稍后将被赋值
 */
let fnCloseChannel01 = () => void 0;
let fnCloseChannel02 = () => void 0;
let fnCloseChannel03 = () => void 0;

// ↓ 首次入场会执行此方法，和在收到实时广播后执行此方法 
const fnListeningRadio = (oMsg)=>{
    const {
        redCountStatic={},
        tableId,
        online,
    } = oMsg.tableInfo;
    if (online >= 0){
        oRoomInfo.online = online;
    }else{
        console.error('实时数据有误');  
        return;
    }
    let hasInserted = false; 
    // 更新本地红包列表 
    oRoomInfo.aPacketsArr.forEach((cur) => {
        const {hasInitialized, originalName} = cur; 
        const oNewState = redCountStatic[originalName] || {};
        const iOldVal = oRoomInfo.oPacketsStatistic[originalName]?.totalAccount || 0;
        const iQtyChanged = (oNewState.totalAccount || 0) - iOldVal;
        const bGidChanged = oNewState.gid && (oNewState.gid != cur.gid); // 得 true 表示旧包消息，下方的包顶上来了 
        const iNowTime = Date.now();
        const pageVisible = document.visibilityState === 'visible'; // 在此实时取值，提升准确性 
        // ↓ 赋值 
        Object.assign(cur, {
            ...oNewState,
            hasInitialized: true, // 表示按上线数据为包数量赋值了 
            sentByMe: oNewState.uid === userStore.id, // 标记是否是用户自己发的包，
        });
        // 这里判断 pageVisible 为 true (页面可见）时才插入包 
        if (iQtyChanged > 0 && hasInitialized && pageVisible){
            hasInserted = true;
            let iMax = (
                gameStore.value.redpacket.fast 
                ? 1 // 快速模式简化动画细节 
                : Math.min(iQtyChanged, 8)  // 最多显示插入 8 个包的动画（减少性能负担）
            ); 
            // ↓ 如果2次插入间隔太近，减少数量，减轻页面性能负担 
            if ((iNowTime - oInsertedPacketAt[cur.num] < 500) && iMax > 1){
                iMax = Math.round(iMax * 0.5);
                // console.log(`连续插入时减量：${iQtyChanged}->${iMax}`);
            }
            for (let idx = 0; idx < iMax; idx++){
                let delay = 125 * idx; 
                const oCard = {
                    id: iNowTime + Math.random(),
                };
                // ↓ 播放一次插入新包动画 
                Sleep(delay).then(()=>{
                    const t01 = Date.now();
                    requestAnimationFrame((t02) => {
                        // ↓ 执行插入时当前页不可见，放弃插入（很少发生）
                        if (t02 - t01 >= 100) return;
                        cur.aList.push(oCard);
                    });
                });
            }
            oInsertedPacketAt[cur.num] = iNowTime;
        }else if (import.meta.env.DEV_MODE && !pageVisible){
            0 && console.log('当前页不可见跳过插入红包动画，可见性：', document.visibilityState); 
        }
        if (0 && iQtyChanged > 0 && import.meta.env.DEV_MODE){ 
            const sPack = originalName.padStart(26, '_');
            const sNum = String(cur.num).padStart(2, ' ') + '人包';
            const sPackInfo = `${sPack} ♦️ ${sNum}: ${iQtyChanged > 0 ? '+' : ''}`;
            console.log(sPackInfo, iQtyChanged);
        }
    });
    hasInserted && fnFakeCardsCleaner();
    Object.assign(
        oRoomInfo.oPacketsStatistic,
        redCountStatic,
    );
    fnCollectionChecker(); 
}

const fnFakeCardsCleaner = (()=>{
    let actionLastTime = 0;
    let myTimer = null;
    return ()=>{
        const iNowTime = Date.now();
        if (iNowTime - actionLastTime < 900){
            clearTimeout(myTimer);
        }
        actionLastTime = iNowTime;
        myTimer = setTimeout(()=>{
            // console.log('开始移除旧红包'); 
            const nowMS = Date.now();
            oRoomInfo.aPacketsArr.forEach((cur, idx) => {
                let iCounter = 0;
                for (const [_, oThis] of cur.aList.entries()){
                    if (nowMS - oThis.id > 2_000){ // 要删除旧的项 
                        iCounter++;
                    }else{
                        break; 
                    }
                }
                if (!iCounter) return; 
                cur.aList.splice(0, iCounter);
                // console.log(`➡️ ${String(cur.num).padStart(2, ' ')}人包 aList.splice(0, ${iCounter})`); 
                // console.log(...cur.aList.map(cur=>{
                //     const [time] = new Date(nowMS - cur.id).toISOString().match(/(?<=t).{8}/i);
                //     return `\n${time} ago`;
                // })); 
            });
        }, 2_200);
    };
})();

/**
 * 自动抢包遍历判断器 
 */
const fnCollectionChecker = () => {
    const aIndex = [...oRoomInfo.aPacketsArr.keys()].sort(()=>{
        // ↓ 一定要洗牌 
        return Math.random() - 0.5;
    });
    for (const idx of aIndex){
        const cur = oRoomInfo.aPacketsArr[idx];
        const newID = cur.gid;
        const oldID = cur.oPreviousGrabed.groupId;
        if (newID && (newID != oldID)){
            // ↓ 指示此方法抢包，此方法内部分判断 
            fnJudgeAndCollect(cur);
        }
    }
}


/**
 * 判断并执行自动抢包 
 */
const fnJudgeAndCollect = async (oPack) => {
    if (
        oPack.sentByMe // 自己发的包 
        || !oAutoRunningManager.collectingAutoOn // 没启动自动抢包
        || !fnCheckIfBalanceEnough(oPack, true) // 余额不足，无法抢包 
        || !oGlobalStore.wsConnection // 网络掉线 
    ){
        return;
    }
    const ts = Date.now();
    const iGap = ts - iCollectedAt; 
    const sGap = (iGap / 1_000).toFixed(1) + 's';
    if (0 && import.meta.dev){
        console.log('上次抢包', new Date(iCollectedAt).toLocaleString()); 
        console.log('当前时间', new Date(ts).toLocaleString()); 
        console.log('两次间隔', sGap, iGap.toLocaleString());
    }
    const isGapBigEnough = iGap > iAutoCollectingGap;
    const aTarget = oAutoRunningStatistic.value.collecting; 
    const oTargetType = aTarget.find(cur => {
        return cur.value == oPack.num;
    });
    // console.log('全真则抢包：', isGapBigEnough, !!oTargetType); 
    if (!isGapBigEnough || !oTargetType){
        // console.log(oPack.num, `人包，不抢 Gap ${sGap} ==========`);  
        return; // 不抢
    }
    // console.log(oPack.num, `人包，要抢此包 Gap ${sGap} ✅`); 
    oPack.clicked = true; 
    setTimeout(() => {
        oPack.clicked = false; 
    }, 600);
    iCollectedAt = ts;
    await nextTick(); 
    fnCollectPacket(oPack, true);
}


/**
 * 进入房间时执行一次，初始化房间数据 
 */
const fnSetPacketsWhileJoinning = (oMsg) => {
    if (!oMsg?.redCountStatic) {
        console.error('redCountStatic 数据缺失'); 
        return; 
    }
    const aEntries = Object.entries(oMsg.redCountStatic);
    // ↓ 设定红包列表 
    const aPacketsArr = aEntries.map(aThis => {
        const [
            originalName, // 格式示例：redPacket:data:1:1.25:cny 
            oVal, 
        ] = aThis;
        const {
            // '2': tableID，房间ID, 
            '3': rateStr,
            '4': currency,
        } = originalName.split(':');
        const rate = Number(rateStr);
        return {
            ...(oVal as any),
            sentByMe: oVal['uid'] === userStore.id, // 标记是否是用户自己发的包，
            originalName,
            rate,
            currency,
            sRate: Number(rate).toFixed(2),
            aList: [], // 插入包时的目标容器 
            clicked: false, // 用于自动抢包的交互效果 
            hasInitialized: false, // 
            oPreviousGrabed: { // 记录上次抢的旧包的特征，当新包不同于旧包，再次抢包 
                grabbedAt: 0, // 时间戳，未必用得上，占位 
                groupId: '',
            },
        };
    }).sort((aa, bb)=>{
        return aa.num - bb.num; // 升序 
    });
    oRoomInfo.aPacketsArr = aPacketsArr;
    Object.assign(oRoomInfo, {
        aPacketsArr,
        online: oRoomInfo.online, 
    });
}


/**
 * 报告用户已经加入房间，并提到相关数据  
 */
const fnJoinTheHall = ()=>{
    const oResolvers = Promise.withResolvers();
    EMIT_GAME_JOIN(
        getGameApi(),
        { tableId: iTableID.value },
        (tableInfo) => {
            oResolvers.resolve(true); 
            if (tableInfo?.['code'] == '3308'){ // 余额不足 
                fnBackToPortal(); 
                return;
            }
            if (!tableInfo || tableInfo?.['error']){
                showNegativeNotify(tableInfo?.['error']);
                return;
            }
            // ↓ 保存初始化数据 
            fnSetPacketsWhileJoinning(tableInfo);
            fnListeningRadio({ tableInfo }); 
            if (typeof fnCloseChannel01 == 'function'){
                fnCloseChannel01(); // 防止重复注册 
            }
            // ↓ 已经进入房间，开始监听信息 
            fnCloseChannel01 = ON_REDPACKET_BROADCAST(
                fnListeningRadio,
            );
        }, 
    );
    return oResolvers.promise; 
}

// ↓ 提示无法进入此厅 
const fnBackToPortal = async () => {
    const confirmed = await showNoticeDialog({
    title: $tFn('Note'),                          // 标题
    mainText: $tFn('niuniu.lowBalance'),         // 主文本
    displaySubText: $tFn('niuniu.rechargePrompt'),  // 副文本（可选）
    buttonText: $tFn('niuniu.confirmExit'),       // 确认按钮文字
    persistent: true                            // 是否阻止点击外部关闭
  });

  // 根据用户选择执行操作
  if (confirmed) {
    await Sleep(100);
    fnGoToEntrance(); // 跳转到大厅页
  }
}

/**
 * 监听玩家实时操作消息 
 */
const fnListenPlayerInfo = ()=>{
    fnCloseChannel02 = ON_REDPACKET_PLAYER_INFO((oData)=>{
        // console.log('玩家事件：', deepCopy(oData)); 
        if (!oData || oData['error']){
            return;
        }
        const {amount, action} = oData;
        const iStars = Math.floor(oData.send_name.length / 2);
        const staredName = '*'.repeat(iStars) + oData.send_name.slice(iStars);
        const collecter = '*'.repeat(iStars) + oData.username.slice(iStars);
        const sSelf = $tFn('redPacketMines.yourself'); 
        const sSenderName = (
            userStore.id === oData.send_user_id 
            ? sSelf
            : staredName
        );
        if (action == ActionInt.collecting && (amount > 0) == false){
            return; // 不提示损失 
        }
        // $tFn
        let msg = ({
            // 1=发红包，2=抢红包等 
            '1': $tFn('redPacketMines.actionSend', {
                user: sSenderName, 
                type: oData.num,
                qty: oData.count,
            }),
            '2': $tFn('redPacketMines.actionCollect', {
                sender: sSenderName,
                collecter: (
                    userStore.id === oData._id 
                    ? sSelf
                    : collecter
                ),
                amount: getFixed(amount, 2),
            }),
        })[action];
        Object.assign(oData, {
            ts: Date.now() + Math.random(), 
            msg,
        });
        oPlayerCenter.aPlayerMsg.push(oData);
        if (oPlayerCenter.aPlayerMsg.length >= 20){
            oPlayerCenter.aPlayerMsg.splice(0, 10); // 删除头部 
        }
    });
}

/**
 * 监听（当前房间）玩家连杀事件
 */
const fnListenPlayerDeeds = ()=>{
    fnCloseChannel03 = ON_REDPACKET_PLAYER_DEEDS((oData)=>{
        if (!oData || oData['error']){
            return;
        }
        const ts = Date.now() + Math.random();
        // console.log('连续抢包：', deepCopy(oData)); 
        const username02 = (
            userStore.id === oData._id 
            ? $tFn('redPacketMines.yourself')
            : oData.username
        );
        Object.assign(oData, {
            ts,
            username02,
        });
        if (oPlayerCenter.aPlayerDeeds.length >= 2){
            // 删除头部元素 
            oPlayerCenter.aPlayerDeeds.shift(); 
        }
        oPlayerCenter.aPlayerDeeds.push(oData);
        setTimeout(()=>{
            const idx = oPlayerCenter.aPlayerDeeds.findIndex(cur => {
                return cur.ts == ts;
            });
            if (idx >= 0){
                oPlayerCenter.aPlayerDeeds.splice(idx, 1);
            }
        }, 1_500);
    });
}

/**
 * 查看房间内玩家列表 
 */
const fnViewPlayersInRoom = async ()=>{
    oVisible.playerList = true; // 开 
    oPlayerCenter.aPlayerList = [];
    const res = await EMIT_GET_REDPACKET_ROOM_PLAYERS();
    if (!res || res['error'] || !res['userList']){
        return; 
    }
    console.log('res', deepCopy(res)); 
    oPlayerCenter.aPlayerList = res['userList']; 
    oRoomInfo.online = oPlayerCenter.aPlayerList.length; 
};

/* 
 * 指定具体的雷号 
 */
const fnSetBombNo = (idx)=>{
    if (idx == 10){
        fnRandomlySetBombNo();
        return;
    }
    oForm4Sending.mine = idx;
}

/* 
 * 随机指定雷号 
 */
const fnRandomlySetBombNo = async () => { 
    // ↓ 发红包的方法会设定此值为 true 
    isSending = false;
    const aa = 10; 
    const bb = Math.random() * 10; 
    const cc = Math.ceil(aa + bb); 
    for (let idx = 0; idx < cc; idx++){
        if (isSending){
            return; // 正在发红包，不允许随机指定雷号 
        }
        let newVal = (oForm4Sending.mine || 0) + 1;
        if (newVal >= aBombNumbers.at(-1)){
            newVal = aBombNumbers[0];
        }
        oForm4Sending.mine = newVal; 
        await Promise.allSettled([
            Sleep(25),
            nextTick(),
        ]);
    }
};

/**
 * 横向移动红包
 * @param iDirection 
 */
const fnMoving = (iDirection:number)=>{
    let newVal = iOffset.value + iDirection;
    const [min, max] = [3, 5];
    if (newVal < min) {
        newVal = max;
    } else if (newVal > max) {
        newVal = min;
    }
    // console.log('newVal --', newVal); 
    iOffset.value = newVal;
};

/**
 * 下注（发红包）
 */
const fnSendOnePacket = async (
    autoSending=false,
) => {
    if (oForm4Sending.mine === null){
        showNegativeNotify({
            i18n: 'redPacketMines.chooseNumber',
        });
        iFirstRowShaking.value = true; 
        Sleep(500).then(() => {
            iFirstRowShaking.value = false; 
        });
        return;
    }
    if (fnCheckIfBalanceEnough() == false){
        return;
    }
    // ↓ 终止通过设定终止随机雷号动画 
    isSending = true;
    const oParams = {
        "frontID": Date.now(), 
        "action": ActionInt.sending,
        "count": Number(oForm4Sending.count),  // 发多少包 
        "num": Number(oForm4Sending.num), // 一包分几份 
        "mine": Number(oForm4Sending.mine), // 雷号 
    };
    // ↓ 仅用于开发阶段调试使用
    // if (isDEV && autoSending === true){
    //     await fnRandomlySetBombNo();
    //     const aSendingConfig  = deepCopy(
    //         oAutoRunningStatistic.value.sending,
    //     ).filter(cur=>{
    //         return cur.checked;
    //     }).sort(()=>{
    //         return Math.random() - 0.5; 
    //     });
    //     const numArr = aSendingConfig.map(cur => {
    //         return Number(cur.value);
    //     });
    //     // console.log('aSendingConfig', numArr); 
    //     Object.assign(oParams, {
    //         num: numArr[0], // 拆分方案 
    //     });
    // }
    oMusic.oAudio.sending.toPlay();
    const res = await EMIT_REDPACKET_BET(oParams);
    if (!res || res?.['error']){
        if (res?.['code'] == 4000){
            fnJoinTheHall();
            showNegativeNotify({
                i18n: 'redPacketMines.failedPleaseTryAgain', 
            }); 
        }else{
            showNegativeNotify(res?.['error']); 
        }
        return;
    }
    // console.log('发包结果 ↓\n', deepCopy(res)); 
    isSending = false;
    return res; 
}

// ↓ 为手动抢包进行可行性检查 
const fnCheckIfCollectable = (
    packType,
    isAutoCollecting,
): Boolean => {
    let i18n = '';
    const ts = Date.now();
    const iGap = ts - iCollectedAt; 
    let position = 'top';
    if (packType.sentByMe){
        // 不能抢自己发的包 
        i18n = 'redPacketMines.CannotCollectYourOwn';
    }else if (!packType.totalAccount){
        // 没有包不能抢 
        i18n = 'redPacketMines.NoRedPacket'; 
    }else if (!fnCheckIfBalanceEnough(packType, true)){
        // 没有余额不能抢 
        i18n = 'commonInfo.noBlance';
    }else if (!isAutoCollecting && (iGap < iManualCollectingGap)){
        // 手动抢包时动作太频繁也应回绝此操作 
        i18n = 'redPacketMines.CollectionTooOften'; 
        position = 'center';
    }
    if (i18n){
        showNegativeNotify({
            type: 'warning',
            position, 
            timeout: 1.5 * 1_000, 
            i18n, 
        });
        return false; 
    }
    return true; // 可以抢包 
};

/**
 * 抢红包（点击某个红包的事件） 
 * 自动抢红包方法最终也调用此方法 
 */
const fnCollectPacket = async (
    packType, // 目标包 
    isAutoCollecting=false, // 显示当前是否是自动抢 
)=>{
    if (fnCheckIfCollectable(packType, isAutoCollecting) == false){
        return; 
    }
    iCollectedAt = Date.now();
    oMusic.oAudio.collecting.toPlay();
    fnCloseResult(); // 先关闭旧的游戏结果 dom  
    await nextTick(); // 等待关闭结束 
    const {totalAccount} = packType; 
    // ↓ 内部是请求前先执行的部分 
    {
        if (!isAutoCollecting){
            packType.totalAccount = Math.max(0, totalAccount - 1); 
        }
        oGameResult.hasWon = null; // 设为“输赢不明” 
        Object.assign(oVisible, {
            resultVisible: true, // 弹出遮罩 
        });
    }
    Object.assign(packType.oPreviousGrabed, {
        grabbedAt: Date.now(),
        groupId: packType.gid, // 记录当前包的 id 
    });
    const [oResult01] = await Promise.allSettled([
        EMIT_REDPACKET_BET({
            "frontID": Date.now(), 
            "action": ActionInt.collecting,
            "num": Number(packType.num), // 分割方案 
            "mine": Number(packType.mine), //雷号 
        }),
        (
            isAutoCollecting == true 
            ? Sleep(600) // ←慢些，使插入包的动画播放完毕后再播放游戏结果 
            : null
        ),
    ]);
    const oRes = oResult01['value'];
    const wrong = !oRes || oRes['error']; 
    if (isAutoCollecting === true){
        aAutoCollectionRecords.push(!wrong); // 插入成功性记录 
        const aLastThree = aAutoCollectionRecords.slice(-3);
        const isAllFalse = aLastThree.every(cur => cur === false); 
        if (isAllFalse){
            console.log('抢包连续失败，终止自动抢包 ❌'); 
            oAutoRunningManager.collectingAutoOn = false; // 关闭 
            clearInterval(oAutoRunningManager.autoCollectingTimer); 
            // 在此 return 终止，连弹出消息都不需要了，因为之前的错误已经弹出2次了
            return;
        }
    }else{
        aAutoCollectionRecords.splice(0, 1/0); 
    }
    if (wrong){
        fnCloseResult();
        if (oRes?.['code'] == 4000){
            fnJoinTheHall();
            if (!isAutoCollecting){
                // ↓ 仅在手动模式弹出抢包失败的提示  
                showNegativeNotify({
                    i18n: 'redPacketMines.failedPleaseTryAgain', 
                }); 
            }
        }else{
            showNegativeNotify(oRes['error']); 
        }
        return;
    }
    const hasWon = oRes['winAmount'] > 0; 
    const iDelay = hasWon ? 400 : 350; 
    console.log(`抢包结果： ${hasWon ? 'win' : 'lose'} ↓\n`, deepCopy(oRes)); 
    Object.assign(oGameResult, {
        ...oRes,
        hasWon,
    });
    Promise.allSettled([
        nextTick(),
        Sleep(iDelay),
    ]).then(()=>{
        oVisible.phase02 = true;
    });
    if (hasWon){
        oMusic.oAudio.win.toPlay();
    }else{
        oMusic.oAudio.lose.toPlay();
    }
    timer4CloseGameResult = setTimeout(()=>{
        // 关闭浏览结果 dom  
        oVisible.resultVisible = false; 
    }, 2_500);
}

/**
 * 检查用户余额是否足够参与游戏（发包/抢包） 
 */
const fnCheckIfBalanceEnough = (
    oPack=null, // 要抢的包信息，不传此值表示要发包
    keepSilence=false,
)=>{
    const balance = userStore.oNowCurrency.balance; 
    let isEnough = false; 
    if (oPack){
        // 有入参，表示要抢这个包 
        const fAtLeastBalace = oRoomConfig.value?.base * oPack.rate; 
        isEnough = balance >= fAtLeastBalace; 
    }else{
        // 在发包 
        const base = Number(oRoomConfig.value?.base);
        const fMoneyNeeds = base * oForm4Sending.count;
        isEnough = balance >= fMoneyNeeds;
    }
    if (!isEnough && !keepSilence){
        showNegativeNotify({
            position: 'top', 
            type: 'warning',
            i18n: 'commonInfo.noBlance', 
        });
    }
    return isEnough;
}



/**
 * 关闭游戏结果动画元素 
 */
const fnCloseResult = ()=>{
    clearTimeout(timer4CloseGameResult);
    oVisible.phase02 = true;
    oVisible.resultVisible = false;
    oGameResult.hasWon = null; // 设为“输赢不明” 
}


let ObserverTimer01 = null; 

/**
 * 监听窗口高度变化（用于缩放适配）
 *
 */
const watchHeightChanging = (
    type: 'start' | 'stop',
)=>{
    const el = oStageDom.value;
    if (!el){
        return console.log('dom 未加载'); 
    }
    if (type == 'start'){
        el._resizeObserver = new ResizeObserver((entries) => {
            clearTimeout(ObserverTimer01);
            ObserverTimer01 = setTimeout(()=>{
                for (const entry of entries) {
                    // ↓ 获取最新高度（包含边框和滚动条）
                    const height = entry.target?.['offsetHeight'];
                    iStageHeight.value = Number.parseInt(height);
                }
            }, 100);
        });
        el._resizeObserver.observe(el); // 开始观察
    }else if (type =='stop'){
        // 组件卸载时销毁观察器 
        if (el._resizeObserver) {
            el._resizeObserver.disconnect();
            delete el._resizeObserver;
        };
    }
}


// 获得滑动角度
function getAngle(angx, angy) {
    return Math.atan2(angy, angx) * 180 / Math.PI;
};

// 根据起点终点返回方向 1向上滑动 2向下滑动 3向左滑动 4向右滑动 0点击事件
function getDirection(startx, starty, endx, endy) {
    var angx = endx - startx;
    var angy = endy - starty;
    var result = 0;

    //如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
    }

    var angle = getAngle(angx, angy);
    if (angle >= -135 && angle <= -45) {
        result = 1;
    } else if (angle > 45 && angle < 135) {
        result = 2;
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
        result = 3;
    } else if (angle >= -45 && angle <= 45) {
        result = 4;
    }
    return result;
}


let startx, starty;

const fnTouchstart = (e)=>{
    startx = e.touches[0].pageX;
    starty = e.touches[0].pageY;
    // console.log('X,Y', startx, starty); 
};

/**
 * 监听用户左右滑动
 * @param e 
 */
const fnTouchend = (e) => {
    let endx, endy;
    endx = e.changedTouches[0].pageX;
    endy = e.changedTouches[0].pageY;
    let direction = getDirection(
        startx,
        starty,
        endx,
        endy,
    );
    const sEventName = ({
        '0': '点击',
        '1': '向上',
        '2': '向下',
        '3': '向左',
        '4': '向右',
        '5': '点击',
    }[direction]);
    // console.log('thisAction', sEventName);
    if (sEventName == '向左'){
        fnMoving(1);
    }else if(sEventName == '向右') {
        fnMoving(-1);
    }
}

/**
 * 监听滑动事件 
 *
 */
const watchSliding = ( 
    type: 'start' | 'stop',
)=>{
    const slider = oCardsBoxDom.value;
    if (!oCardsBoxDom.value){
        return console.log('dom 当前未加载'); 
    }
    console.log('watchSliding()', type); 
    if (type == 'start'){
        slider.addEventListener('touchstart', fnTouchstart, false);
        slider.addEventListener('touchend', fnTouchend, false);
    }else { 
        slider.removeEventListener('touchstart', fnTouchstart, false);
        slider.removeEventListener('touchend', fnTouchend, false);
    }
}


// ↓ 切换房间 
const fnChangeHall = async (oHall) => {
    if (oHall.disabled) {
        showNegativeNotify({
            i18n: 'redPacketMines.lowBalance',
        }); 
        return; // 余额不足 
    }
    if (oAutoRunningManager.collectingAutoOn){
        const oResolvers = Promise.withResolvers();
        // Dialog.create({
        //     title: $tFn('Note'),
        //     message: $tFn('redPacketMines.switchConfirm'), 
        //     persistent: true,
        //     style: { 'width': '300px' },
        //     transitionHide: 'none', // 关闭退场动画 
        //     ok: {
        //         label: $tFn('commonInfo.confirm'),
        //     },
        //     cancel: {
        //         label: $tFn('Cancel'),
        //     },
        // }).onOk(() => {
        //     oResolvers.resolve(true);
        // }).onCancel(() => {
        //     oResolvers.resolve(false);
        // });
        const result = await showNoticeDialog({
            title: $tFn('Note'),
            mainText: $tFn('exitGame.gameRunning'),
            mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
            giftIcon: false,
            cancelButtonText: $tFn('exitGame.cancel'),
            buttonText: $tFn('exitGame.confirm'),
            themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
            dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,           // 狗狗图片（可选）
            bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,          // 背景图片（可选）
            oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,          // 浮动图片（可选）
        });
        if (result) {
            oResolvers.resolve(true);
        } else {
            oResolvers.resolve(false);
        }
        const answer = await oResolvers.promise; 
        console.log('answer:', answer); 
        if (!answer) {
            return;
        }
    }

    oVisible.hallList = false; 
    // ↑ 先把窗口关闭 
    await nextTick(); 
    const room = $tFn(`redPacketMines.hall0${oHall.intLevel}`);
    setTimeout(()=>{
        showNegativeNotify({
            type: 'positive',
            position: 'top',
            timeout: 1_000 * 1.5, 
            message: $tFn('redPacketMines.enteredRoom', {
                room,
            }),
        });
    }, 100);
    fnGoIntoOneHall(
        oHall,
        {replace: true}, // 不生成浏览器页面历史 
    );
}


const showHistoryList = ()=>{
    oVisible.historyList = true; 
};

function handleVisibilityChange() {
    isPageVisible.value = document.visibilityState === 'visible';
    // console.log('isPageVisible：', isPageVisible.value);
}

// ↓ 为房间默认金额赋值 
watch(
    () => oRoomConfig.value,
    (oNewVal) => {
        const todo = (
            import.meta.client
            && oNewVal.base
            && !Number(oForm4Sending.amount) // 待赋值 
        ); 
        if (!todo) return; 
        const amount = Number(oNewVal.base).toFixed(2);
        Object.assign(oForm4Sending, {
            amount,
        });
    },
    {immediate: true},
);


// ↓ 防止发送超量的包 
watch(
    () => oForm4Sending.count,
    (count) => {
        if (count == 1) { 
            return; 
        }
        if ((count > iMaxPacketSendable.value) && iMaxPacketSendable.value){
            oForm4Sending.count = iMaxPacketSendable.value; 
        }
    },
    // {immediate: true},
);


// ↓ 余额不足时关闭自动抢包 
watch(
    aPacketCollectable,
    (aNewArr) => {
        // console.log('aNewArr', deepCopy(aNewArr)); 
        const toStopThat = (
            oAutoRunningManager.collectingAutoOn 
            && !aNewArr.length
        );
        if (!toStopThat) return; 
        joinStateStore.gameRunning = false; 
        oAutoRunningManager.collectingAutoOn = false; 
        showNegativeNotify({
            type: 'warning',
            position: 'top',
            timeout: 1_000 * 1.5, 
            message: $tFn('redPacketMines.autoModeIsStoping'),
        });
    },
    // {immediate: true},
);


// ↓ ws 重连时关闭遮罩 
watch(
    () => oGlobalStore.wsConnection,
    (bNew, bOld) => {
        console.log('wsConnection ♦️♦️♦️', bNew); 
        toCloseLoading(); 
        if (!bNew) return; 
        fnJoinTheHall(); // 加入房间，同时查询配置信息等  
    },
);


/* 
----------------------------------------------------------
-------- ↓ 最下方，生命周期 ------------------------------- 
----------------------------------------------------------
*/

if (import.meta.client) {
    toCloseLoading(); 
}

onMounted(async ()=>{
    console.log('房间：开始进入 ▶️ 房间号：', oRoute?.params?.id); 
    // ↓ 减速以避让，使“退出房间” 的事件“先” 执行完毕 
    await nextTick();
    fnJoinTheHall(); // 加入房间，同时查询配置信息等  
    fnListenPlayerInfo(); // 监听房间玩家信息 
    fnListenPlayerDeeds(); // 监听房间玩家连杀事件 
    watchHeightChanging('start');
    watchSliding('start');
    toCloseLoading(); 
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // ↓ 用于测试 
    // if (import.meta.dev){
    //     setInterval(()=>{
    //         console.log('退出房间了');
    //         EMIT_REDPACKET_LEAVE();
    //     }, 12 * 1000);
    // }
});

/**
 * 路由离开守卫 - 红包游戏使用自己的拦截逻辑
 * 逻辑与全局中间件保持一致：只拦截往前跳一级的情况
 */
onBeforeRouteLeave(async (to, from, next) => {
  if (!import.meta.client) return;
  // 如果已经退出过房间，直接允许导航（避免重复处理）
  if (isRoomExited.value) {
    return next();
  }
  
  // 检查游戏是否正在进行（自动抢包开启时认为游戏正在进行）
  if (joinStateStore.gameRunning || oAutoRunningManager.collectingAutoOn) {
    // 如果已经询问过，阻止导航但不累积历史记录
    if (redpacketAskSum > 0) {
      console.log('[路由守卫] 弹窗已显示，阻止重复导航');
      return next(false); // 阻止导航
    }
    
    // 保存第一次尝试跳转的目标路径
    redpacketPendingNavigation = to;

    // 询问计数器加1
    redpacketAskSum = redpacketAskSum + 1;

    // 🔒 临时禁用浏览器返回事件，防止弹窗期间累积历史记录
    const originalPopstateHandler = window.onpopstate;
    window.onpopstate = null;
    console.log('[路由守卫] 已临时禁用浏览器返回事件');

    try {
      // 弹出确认弹窗
      const result = await showNoticeDialog({
      title: $tFn('Note'),
      mainText: $tFn('exitGame.gameRunning'),
      mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
      giftIcon: false,
      cancelButtonText: $tFn('exitGame.confirm'), // 确认离开
      buttonText: $tFn('exitGame.cancel'),        // 取消（继续游戏）
      themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
      dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,
      bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,
      oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,
    });

    // 与全局中间件逻辑一致：result = true 表示点击取消按钮（继续游戏）
    // result = false 表示点击确认按钮（离开游戏）
    // 这里的逻辑是：isConfirmLeave = !result
    const isConfirmLeave = !result;

    if (isConfirmLeave == false) { // 用户决定不走，要留下
      redpacketAskSum = 0; // 询问次数归零
      redpacketPendingNavigation = null; // 清空保存的目标路径
      return next(false); // 终止页面跳转，留在当前游戏
    } else {
      redpacketAskSum = 0; // 询问次数归零
      
      // 关键修复：先清理游戏状态和退出房间
      try {
        // 退房声明
        EMIT_REDPACKET_LEAVE();
        // 销毁消息监听器
        fnCloseChannel01(); 
        fnCloseChannel02(); 
        fnCloseChannel03(); 
        // 关闭自动发/抢包定时器
        clearInterval(oAutoRunningManager.autoSendingTimer); 
        clearInterval(oAutoRunningManager.autoCollectingTimer);
        // 关闭 DOM 监听
        watchHeightChanging('stop');
        watchSliding('stop');
        oMusic.toDestory();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        
        // 标记已退出房间
        isRoomExited.value = true;
      } catch (error) {
        console.error('[路由守卫] 清理资源失败:', error);
      }
      
      // 重置游戏运行状态
      joinStateStore.gameRunning = false;
      
      // 使用保存的第一次目标路径进行跳转
      const targetPath = redpacketPendingNavigation;
      redpacketPendingNavigation = null; // 清空保存的目标路径
      
      if (targetPath) {
        console.log('[路由守卫] 跳转到目标路径:', targetPath.path);
        return next(targetPath);
      } else {
        return next();
      }
    }
    } finally {
      // 🔓 恢复浏览器返回事件监听
      window.onpopstate = originalPopstateHandler;
      console.log('[路由守卫] 已恢复浏览器返回事件');
    }
  } else {
    // 游戏未进行，直接允许离开
    console.log('[路由守卫] 游戏未进行，直接允许离开');
    return next();
  }
});

onBeforeUnmount(()=>{
    console.log('房间：开始退出 ⏹️ 房间号：', oRoute?.params?.id);
    
    // 如果已经通过路由守卫退出，跳过重复清理
    if (isRoomExited.value) {
      console.log('房间：已通过路由守卫退出，跳过 onBeforeUnmount 清理');
      return;
    }
    
    // ↓ 退房声明（置于顶部使早执行） 
    EMIT_REDPACKET_LEAVE();
    // ↓ 销毁消息监听器 
    fnCloseChannel01(); 
    fnCloseChannel02(); 
    fnCloseChannel03(); 
    // ↓ 关闭自动发/抢包定时器
    clearInterval(oAutoRunningManager.autoSendingTimer); 
    clearInterval(oAutoRunningManager.autoCollectingTimer); 
    // ↓ 关闭 DOM 监听 
    watchHeightChanging('stop');
    watchSliding('stop');
    oMusic.toDestory(); 
    console.log('房间：退出完毕');
    document.removeEventListener('visibilitychange', handleVisibilityChange);
});

</script>

<style scoped src="./style/indoor.scss" ></style>
<!-- ↓ 游戏下方表单 -->
<style scoped src="./style/game-form.scss" ></style> 
<!-- ↓ 游戏结果遮罩 -->
<style scoped src="./style/game-result-animation.scss"></style> 

